define('evicommon/spf/paginate.adapter',['require','exports','module','underscore','../state/param.adapter','./model/paginate'],function(require, exports, module){
  var _            = require('underscore');
  var ParamAdapter = require('../state/param.adapter');
  var Paginate     = require('./model/paginate');

  var Adapter = ParamAdapter.extend({

    options: { zeroIndexed: true },

    postprocess: function(data, resp) {
      var page = _.omit(resp.page, 'sort', 'first', 'last');
      page = this.handleLegacyResponse(page);
      if (this.options.zeroIndexed && _.has(page, Paginate.PAGE)) {
        ++page[Paginate.PAGE];
      }
      this.model.set(page, { ignoreAutoFetch: true });
    },

    serializeModel: function() {
      var data = ParamAdapter.prototype.serializeModel.apply(this, arguments);
      if (this.options.zeroIndexed) {
        --data[Paginate.PAGE];
      }
      var queryData = {};
      queryData[Paginate.QUERY_PAGE] = data[Paginate.PAGE];
      queryData[Paginate.QUERY_SIZE] = data[Paginate.SIZE];
      return queryData;
    },

    handleLegacyResponse: function(page) {
      if (page.page) {
        page.number = page.page;
        delete page.page;
      }

      if (page.totalpages) {
        page.totalPages = page.totalpages;
        delete page.totalpages;
      }

      if (page.totalelements) {
        page.totalElements = page.totalelements;
        delete page.totalelements;
      }

      return page;
    }

  });

  module.exports = Adapter;
});

